<script>
  import Separator from '../../ui/Separator/Separator.svelte'
  import closeIcon from 'assets/imgs/icons/close-icon.svg'
  import { isDrawerOpen, drawerComponent, closeDrawer } from '../../../stores/drawer'
  import Emulate from '../../../app/routing/emulate/Emulate.svelte'

</script>

<style>
  .drawer-title {
    font-family: Roboto;
    font-size: 20px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
    display: flex;
    justify-content: space-between;
    margin-left: 1.5rem;
    margin-right: 1rem;
    margin-top: 1.5rem;
  }

  .drawer {
    position: absolute;
    display: var(--isOpen);
    right: 0px;
    top: 4.3rem;
    height: calc(100vh - 69px);
    overflow-x: hidden;
    overflow-y: scroll;

    width: 583px;
  }

  @media (max-width: 767px) {
    .drawer {
      width: 100%;
      top: 4.3rem;
      height: 100vh;
    }
  }
</style>

{#if $isDrawerOpen}
  <div class="drawer bg-white flex flex-col" data-cy="drawer">
    <div class="drawer-title" data-cy="drawer-title">
      <span class="font-roboto text-20 left-4 font-bold leading-18 tracking-0.02em text-black">
        {#if $drawerComponent === 'emulate'}
          Emulate User
        {/if}
      </span>
      <button class="text-black top-4 right-4 border-solid border-red-400" onclick={closeDrawer} data-cy="toggle-drawer-button">
        <img src={closeIcon} alt="toggle-drawer" />
      </button>
    </div>
    <Separator />

    <div data-cy="drawer-content">
      {#if $drawerComponent === 'emulate'}
        <Emulate />
      {/if}
    </div>
  </div>
{/if}
